
/*eslint-disable no-unused-vars*/
import React from 'react';
/*eslint-enable no-unused-vars*/

import { Form, Field, reduxForm } from 'redux-form';
import { ReduxRecaptcha, ReduxInput} from '../ReduxInput';
import { isRequired } from '../ReduxInput/Validators';
import {
 Label,   FormGroup,  Button
} from 'reactstrap';

class ResetForm extends React.Component {

  render() {
    const { handleSubmit } = this.props;


    return (
      <Form onSubmit={handleSubmit} id="login-form" className="smart-form client-form">
        <FormGroup className="mb-4">
          <Label htmlFor="email">Email </Label>
          <Field
            iconClass="fa fa-user"
            name="email"
            type="email"
            placeholder="email address"
            component={ReduxInput}
            validate={[isRequired]}
          />
        </FormGroup>
        <FormGroup>
          <Field
            name="g-recaptcha-response"
            component={ReduxRecaptcha}
          />
        </FormGroup>
        <FormGroup>
          <Button id="sign-in-button" type="submit" color="primary">
            Request Reset
        </Button>
        </FormGroup>
      </Form>

    );
  }
}

export default reduxForm({
  form: "ResetForm",   // a unique identifier for this form
  destroyOnUnmount: false,         // preserve form data
  forceUnregisterOnUnmount: true,  // unregister fields on unmount
})(ResetForm);






// WEBPACK FOOTER //
// ./src/components/ResetPassword/ResetPasswordForm.js